export const RESCUE_RECIPES = {
    /* ============================================================
       TRANSFORMATION KNOWLEDGE BASE (ID BASED)
       Note: 'legacy_ids' is used for backward compatibility with 
       older notifications that only contain item names.
       ============================================================ */

    'domates_sos': {
        legacy_ids: ['domates', 'domates_sos_v1'],
        transformVersion: 1,
        rescueKind: 'RECIPE',
        sourceIngredient: ['domates'],
        fromState: ['olgun', 'artmis'],
        riskTags: { baby: true, diabetic: true, lowSodium: false },
        targetName: 'Mutfak Sosu (Konserve)',
        targetDictionaryId: 'cmm6mg6et0000lvosun1hsji8',
        producedAmount: 650,
        producedUnit: 'g',
        targetIcon: 'soup_kitchen',
        description: 'Domateslerinizi 0.5gr hassasiyetle lezzetli bir sosa dönüştürün!',
        steps: [
            'Domatesleri yıkayın, kabuklarını soyup yemeklik doğrayın veya pürüzsüz bir kıvam için blenderdan geçirin.',
            'Geniş bir tencerede, orta ateşte domatesler suyunu çekip rengi koyulaşana kadar yaklaşık 15-20 dakika kaynatın.',
            'Kaynama esnasında yüzeyde oluşan köpükleri bir kevgir yardımıyla alın ki sosunuz daha parlak ve dayanıklı olsun.',
            'İstenilen kıvama gelince (Bebek payını ayırdıktan sonra) kaya tuzunu ekleyip bir taşım daha kaynatın.'
        ],
        babySafetyStep: '⚠️ BEBEK KORUMASI: Tuz eklemeden önce {{babyName}} için 2 porsiyon (yaklaşık 200gr) ayır!',
        storageInstructions: 'Kavanozda 2 parmak boşluk bırak, üzerine 15 ml ZEYTİNYAĞI dök. 6 ay korur.',
        estimatedValue: 45,
        extendedShelfLifeDays: 180,
        unit: 'Kavanoz',
        storageLocation: 'Kiler',
        mainZone: 'Pantry',
        subZone: 'Canned Goods'
    },

    'biber_salcasi': {
        legacy_ids: ['biber'],
        transformVersion: 1,
        rescueKind: 'RECIPE',
        sourceIngredient: ['biber'],
        fromState: ['olgun', 'artmis'],
        riskTags: { baby: true, diabetic: true, lowSodium: false },
        targetName: 'Biber Salçası / Sosu',
        targetDictionaryId: 'cmltr5e2x004wlvscb788a1j2',
        producedAmount: 400,
        producedUnit: 'g',
        targetIcon: 'soup_kitchen',
        description: 'Biberlerinizi uzun ömürlü hale getirin.',
        steps: [
            'Biberleri yıkayıp sap ve çekirdek kısımlarını tamamen temizleyin, ardından püre haline getirin.',
            'Geniş tabanlı bir tencerede, kısık ateşte sürekli karıştırarak suyunu tamamen çekip macun kıvamına gelene kadar pişirin.',
            'Sıcakken sterilize edilmiş kavanozlara doldurup ters çevirerek vakumlanmasını sağlayın.'
        ],
        babySafetyStep: '⚠️ BEBEK KORUMASI: Tuz eklemeden önce {{babyName}} için ayır!',
        storageInstructions: 'Üzerine zeytinyağı dökerek hava temasını kes.',
        estimatedValue: 60,
        extendedShelfLifeDays: 180,
        unit: 'Kavanoz',
        storageLocation: 'Buzdolabı',
        mainZone: 'Fridge',
        subZone: 'Sauces'
    },

    'karamelize_sogan': {
        legacy_ids: ['soğan'],
        transformVersion: 1,
        rescueKind: 'PREPARATION',
        sourceIngredient: ['soğan'],
        fromState: ['olgun', 'artmis'],
        riskTags: { baby: true, diabetic: true, lowSodium: true },
        targetName: 'Karamelize Soğan Bazı',
        targetDictionaryId: 'cmqe4jqsp0000lv6sydvstbiv',
        producedAmount: 300,
        producedUnit: 'g',
        targetIcon: 'skillet',
        description: 'Soğanları altın değerinde yemek bazına dönüştür.',
        steps: [
            'Soğanları piyazlık (ay şeklinde) ince ince doğrayın ve yapışmaz bir tavaya alın.',
            'Zeytinyağını ekleyip en kısık ateşte, soğanlar kendi şekerini salıp karamel rengini alana kadar yaklaşık 40 dakika sabırla pişirin.',
            'Yanmasını önlemek için 5 dakikada bir tahta kaşıkla diptekileri üste alacak şekilde nazikçe karıştırın.'
        ],
        babySafetyStep: '⚠️ BEBEK NOTU: Tuz eklemeden önce {{babyName}} için 100 gr ayır.',
        storageInstructions: 'Cam kavanozda, yüzeyine 10 ml zeytinyağı ekle.',
        estimatedValue: 35,
        extendedShelfLifeDays: 14,
        unit: 'Gram',
        storageLocation: 'Buzdolabı',
        mainZone: 'Fridge',
        subZone: 'Sauces'
    },

    'bebek_puresi': {
        legacy_ids: ['meyve'],
        transformVersion: 1,
        rescueKind: 'PREPARATION',
        sourceIngredient: ['meyve'],
        fromState: ['olgun', 'artmis', 'yumusak'],
        riskTags: { baby: true, diabetic: false, lowSodium: true },
        targetName: 'Bebek Püresi (Şekersiz)',
        targetDictionaryId: 'cmqe4jqxx0003lv6s5lzbe09b',
        producedAmount: 200,
        producedUnit: 'g',
        targetIcon: 'nutrition',
        description: 'Yumuşak meyveleri püreye dönüştürün.',
        steps: [
            'Meyveleri soyup çekirdeklerini çıkardıktan sonra küçük küpler halinde doğrayın.',
            'Az miktarda su ile meyveler tamamen yumuşayana kadar buharda veya tencerede haşlayın.',
            'Haşlanan meyveleri çatal veya blender ile pürüzsüz hale getirip oda sıcaklığına gelene kadar bekletin.'
        ],
        babySafetyStep: '⚠️ 12 ay altı için asla şeker/bal ekleme!',
        storageInstructions: 'Vakumlu cam kavanozda sakla.',
        estimatedValue: 30,
        extendedShelfLifeDays: 15,
        unit: 'Kavanoz',
        storageLocation: 'Buzdolabı',
        mainZone: 'Fridge',
        subZone: 'Fruits'
    },

    'muz_puresi': {
        legacy_ids: ['muz'],
        transformVersion: 1,
        rescueKind: 'RECIPE',
        sourceIngredient: ['muz'],
        fromState: ['kararmis', 'yumusak'],
        riskTags: { baby: true, diabetic: false, lowSodium: true },
        targetName: 'Muz Püresi Bazı',
        targetDictionaryId: 'cmmgsz3eu0009lvosacxn8030',
        producedAmount: 250,
        producedUnit: 'g',
        targetIcon: 'nutrition',
        description: 'Kararan muzları kurtarın.',
        steps: [
            'Kararan muzları soyun ve lifli kısımlarını ayıklayıp bir kaba alın.',
            'Limon suyu (kararmayı önlemek için) ve az su ekleyerek pürüzsüz bir kıvam alana kadar ezin.'
        ],
        babySafetyStep: '✅ BEBEK DOSTU: Şeker ekleme!',
        storageInstructions: 'Cam kavanozda buzdolabında sakla.',
        estimatedValue: 25,
        extendedShelfLifeDays: 3,
        unit: 'Gram',
        storageLocation: 'Buzdolabı',
        mainZone: 'Fridge',
        subZone: 'Fruits'
    },

    'pesto_sos': {
        legacy_ids: ['marul'],
        transformVersion: 1,
        rescueKind: 'RECIPE',
        sourceIngredient: ['marul', 'feslegen'],
        fromState: ['yumusak', 'artmis'],
        riskTags: { baby: true, diabetic: true, lowSodium: true },
        targetName: 'Taze Pesto Sos',
        targetDictionaryId: 'cmm3t8sht0005lvikg07l5eim',
        producedAmount: 200,
        producedUnit: 'g',
        targetIcon: 'spa',
        description: 'Yeşilliklerinizi çöpe atmayın.',
        steps: [
            'Marulları sirkeli suda bekletip kurutun; sosun sulanmaması için yaprakların tamamen kuru olması şarttır.',
            'Zeytinyağı, varsa sarımsak ve kuruyemiş ile birlikte robottan geçirin; kısa aralıklarla (pulse) çekerek rengini karartmamaya özen gösterin.'
        ],
        babySafetyStep: '✅ Sirkeli suda 10 dk beklet.',
        storageInstructions: 'Üzerine 10 ml zeytinyağı gezdir.',
        estimatedValue: 55,
        extendedShelfLifeDays: 30,
        unit: 'Kavanoz',
        storageLocation: 'Buzdolabı',
        mainZone: 'Fridge',
        subZone: 'Sauces'
    },

    'didiklenmis_tavuk': {
        legacy_ids: ['tavuk'],
        transformVersion: 1,
        rescueKind: 'PREPARATION',
        sourceIngredient: ['tavuk'],
        fromState: ['cig', 'haslanmis', 'artmis'],
        riskTags: { baby: true, diabetic: true, lowSodium: true },
        targetName: 'Didiklenmiş Tavuk',
        targetDictionaryId: 'cmm3tyjti0001lvjc3szrccrc',
        producedAmount: 300,
        producedUnit: 'g',
        targetIcon: 'food_bank',
        description: 'Tavuklarınızı porsiyonlayarak saklayın.',
        steps: [
            'Tavukları kemikli olarak (lezzet için) haşlayın ve suyunu çorba yapmak üzere ayırın.',
            'Soğuyan tavukları elinizle küçük liflere ayırarak porsiyonluk paketlere bölün.'
        ],
        babySafetyStep: '⚠️ Tuz eklemeden {{babyName}} için ayır!',
        storageInstructions: '50 gr porsiyonlarla dondur.',
        estimatedValue: 85,
        extendedShelfLifeDays: 90,
        unit: 'Porsiyon',
        storageLocation: 'Derin Dondurucu',
        mainZone: 'Freezer',
        subZone: 'Frozen Meat'
    },

    'kavrulmus_et': {
        legacy_ids: ['et'],
        transformVersion: 1,
        rescueKind: 'PREPARATION',
        sourceIngredient: ['et', 'kiyma'],
        fromState: ['cig', 'artmis'],
        riskTags: { baby: true, diabetic: true, lowSodium: true },
        targetName: 'Kavrulmuş Et / Kıyma',
        targetDictionaryId: 'cmqe4jqv90001lv6slbmth7ip',
        producedAmount: 300,
        producedUnit: 'g',
        targetIcon: 'skillet',
        description: 'Etleri yemeklik hale getir.',
        steps: [
            'Etleri küçük küpler halinde doğrayıp tencereye alın; kapağı kapatıp etler önce suyunu salıp sonra çekene kadar pişirin.',
            'Eti kendi yağıyla 5 dakika daha çevirerek mühürleyin ve soğuduktan sonra dondurucu paketlerine yerleştirin.'
        ],
        babySafetyStep: '⚠️ Yağ ve tuz eklemeden önce ayır!',
        storageInstructions: 'Yassı poşetlerde dondur.',
        estimatedValue: 120,
        extendedShelfLifeDays: 180,
        unit: 'Porsiyon',
        storageLocation: 'Derin Dondurucu',
        mainZone: 'Freezer',
        subZone: 'Frozen Meat'
    },

    'ev_yapimi_lor': {
        legacy_ids: ['süt'],
        transformVersion: 1,
        rescueKind: 'RECIPE',
        sourceIngredient: ['süt'],
        fromState: ['artmis', 'tarihi_yakin'],
        riskTags: { baby: true, diabetic: true, lowSodium: true },
        targetName: 'Ev Yapımı Lor',
        targetDictionaryId: 'cmltr5dui003klvscl1cmjp8p',
        producedAmount: 250,
        producedUnit: 'g',
        targetIcon: 'water_drop',
        description: 'Sütleri değerlendirin.',
        steps: [
            'Sütü kaynama noktasına getirin; tam kabarmaya başladığında limon suyunu gezdirerek ekleyin.',
            'Yeşil suyun ayrıştığını ve pıhtıların oluştuğunu görünce ocağı kapatıp 15 dakika bekleyin.',
            'Tülbent serili süzgeçten süzün ve en az 1 saat suyunun süzülmesi için baskıda bekletin.'
        ],
        babySafetyStep: '✅ Tuz ekleme.',
        storageInstructions: 'Kendi suyuyla 1 hafta sakla.',
        estimatedValue: 40,
        extendedShelfLifeDays: 7,
        unit: 'Gram',
        storageLocation: 'Buzdolabı',
        mainZone: 'Fridge',
        subZone: 'Dairy'
    },

    'suzme_lor': {
        legacy_ids: ['yoğurt'],
        transformVersion: 1,
        rescueKind: 'RECIPE',
        sourceIngredient: ['yoğurt'],
        fromState: ['eksimeye_baslamis', 'artmis'],
        riskTags: { baby: true, diabetic: true, lowSodium: true },
        targetName: 'Süzme Lor',
        targetDictionaryId: 'cmmdx5xyg0006lv2010mqzp1w',
        producedAmount: 250,
        producedUnit: 'g',
        targetIcon: 'water_drop',
        description: 'Yoğurdu peynire çevir.',
        steps: [
            'Yoğurdu bir tencereye alıp ılıyana kadar ısıtın (bu işlem proteinleri birbirine bağlar).',
            'Kesilen yoğurdu tülbent üzerine dökün ve lorun sertleşmesi için üzerine bir ağırlık koyarak 4-6 saat süzün.'
        ],
        babySafetyStep: '✅ Tuz ekleme.',
        storageInstructions: '5 gün saklanır.',
        estimatedValue: 35,
        extendedShelfLifeDays: 5,
        unit: 'Gram',
        storageLocation: 'Buzdolabı',
        mainZone: 'Fridge',
        subZone: 'Dairy'
    },

    'rendelenmis_peynir': {
        legacy_ids: ['peynir'],
        transformVersion: 1,
        rescueKind: 'PREPARATION',
        sourceIngredient: ['peynir'],
        fromState: ['sertlesmis', 'artmis'],
        riskTags: { baby: false, diabetic: true, lowSodium: false },
        targetName: 'Rendelenmiş Peynir',
        targetDictionaryId: 'cmqe4jqwv0002lv6s5y5ce0ef',
        producedAmount: 200,
        producedUnit: 'g',
        targetIcon: 'restaurant',
        description: 'Sertleşen peynirleri kurtar.',
        steps: [
            'Peynirleri türlerine göre ayırın, sertleşmiş kısımları rendeleyin.',
            'Pizzalarda veya böreklerde kullanmak üzere porsiyonlayın.'
        ],
        babySafetyStep: '⚠️ Tuzlu peynir 12 ay altı için uygun değil.',
        storageInstructions: 'Dondurucuda sakla.',
        estimatedValue: 50,
        extendedShelfLifeDays: 90,
        unit: 'Gram',
        storageLocation: 'Derin Dondurucu',
        mainZone: 'Freezer',
        subZone: 'Dairy'
    },

    'galeta_kruton': {
        legacy_ids: ['ekmek'],
        transformVersion: 1,
        rescueKind: 'RECIPE',
        sourceIngredient: ['ekmek'],
        fromState: ['bayat'],
        riskTags: { baby: false, diabetic: false, lowSodium: false },
        targetName: 'Kruton / Galeta',
        targetDictionaryId: 'cmm3t8sh00003lvikx20dg84u',
        producedAmount: 150,
        producedUnit: 'g',
        targetIcon: 'bakery_dining',
        description: 'Bayat ekmekleri değerlendir.',
        steps: [
            'Bayat ekmekleri eşit boyutlarda küpler halinde doğrayın.',
            'Üzerine çok az zeytinyağı gezdirip fırın tepsisine tek kat halinde yayın.',
            '160°C fırında, ekmekler tamamen kuruyup altın sarısı renk alana kadar yaklaşık 15-20 dakika fırınlayın.'
        ],
        babySafetyStep: '⚠️ 12 ay altı için uygun değildir.',
        storageInstructions: 'Kuru cam kavanozda sakla.',
        estimatedValue: 25,
        extendedShelfLifeDays: 30,
        unit: 'Gram',
        storageLocation: 'Kiler',
        mainZone: 'Pantry',
        subZone: 'Dry Goods'
    }
};

/**
 * Finds a rescue recipe by ID or legacy name.
 * @param {string} identifier - The transform_id or a legacy name/ID.
 * @returns {object|null} The recipe object or null if not found.
 */
export const getRescueRecipe = (identifier) => {
    if (!identifier) return null;

    // 1. Direct match by ID
    if (RESCUE_RECIPES[identifier]) return RESCUE_RECIPES[identifier];

    // 2. Match by legacy_ids
    const foundKey = Object.keys(RESCUE_RECIPES).find(key =>
        RESCUE_RECIPES[key].legacy_ids && RESCUE_RECIPES[key].legacy_ids.includes(identifier.toLowerCase())
    );

    return foundKey ? RESCUE_RECIPES[foundKey] : null;
};
